import styled from 'styled-components';

export const ParameterArea = styled.div`
    padding: 10px 10px;
    border: 1px solid #ddd;

    .row {
        margin: 10px 0px;
    }
`;

export const ActionItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    input {
        text-align: center;
    }
`;

export const TimelineItem = styled.div`
    border: 1px solid #ddd;

    :hover {
        cursor: move;
    }

    .MuiSelect-root {
        text-align: center;
    }
`;

export const IconParameter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    margin: 0px;
    padding: 0px;

    :hover {
        cursor: pointer;
    }
`;
